<template>
  <div id="SysUrlRedirectList">
    <eb-header>
      <eb-break-crumb slot='breakCrumb' />
      <eb-search @search-click='loadUrlRedirectDataBySearchWord' slot='search' />
    </eb-header>
    <div class="box-header">
      <div class="box-header-right">
        <el-button @click="showAddUrlWindow" class="eb-button-red eb-button-small">增加信息</el-button>
        <el-button :disabled="isEditStatus" @click="showEditUrlWindow" class="eb-button-red eb-button-small">修改信息</el-button>
        <el-button :disabled="isDelStatus" @click="deleteUrlAndUser" class="eb-button-red eb-button-small">删除信息</el-button>
      </div>
    </div>
    <div class="table-box">
      <div class="eb-table">
        <el-table :data="pageData.urlRedirectList" :stripe="true" row-key="urlId" @selection-change="handleSelectionChange" ref="pushListRef"
          style="width: 100%">
          <el-table-column :reserve-selection="true" type="selection" width="40"></el-table-column>
          <el-table-column sortable prop="urlCode" label="URL编码" width="110"></el-table-column>
          <el-table-column sortable prop="jumpUrl" label="跳转到地址"></el-table-column>
          <el-table-column sortable prop="urlDesc" label="URl描述" width="110"></el-table-column>
          <el-table-column sortable prop="version" label="URL版本" width="110"></el-table-column>
          <el-table-column sortable prop="itLatested" label="当前版本" width="110">
             <template slot-scope='scope'>
              {{scope.row.itLatested === true ? '是' : '否'}}
            </template>
          </el-table-column>
          <el-table-column sortable prop="createDate" label="创建时间" width="130">
            <template slot-scope='scope'>
              {{scope.row.createDate|dateTimeStandardFormat}}
            </template>
          </el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="130">
            <template slot-scope='scope'>
              {{scope.row.updateDate|dateTimeStandardFormat}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <eb-pagination class="pagination" :current-page.sync="searchParams.start" v-if="searchParams.length" @current-change="onPageChange"
      :total="pageData.recordsTotal" />
    <UrlRedirectDialog @onSuccess="onSuccess" :isVisible.sync='dialogVisible' :urlInfo='urlInfo' />
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import EbPagination from '@/components/common/eb-pagination/eb-pagination';
import UrlRedirectDialog from '@/components/sys/UrlRedirectDialog';
import { clone } from 'lodash';
import { listUrlRedirect, deleteurlList } from '@/services/system-service';
import moment from 'moment';
export default {
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    EbPagination,
    UrlRedirectDialog
  },
  data() {
    return {
      initSearchParams: {
        length: 10,
        start: 1
      },
      searchParams: null,
      pageData: {
        urlRedirectList: [],
        recordsTotal: 0
      },
      isEditStatus: true,
      isDelStatus: true,
      urlIds: [],
      dialogVisible: false,
      urlRedirectInfo: {},
      urlInfo: {
        dialogVisible: false,
        operType: 'add',
        urlId: null,
        urlCode: null,
        version: null,
        jumpUrl: null,
        urlDesc: null
      }
    };
  },
  computed: {
    paginationSize() {
      return this.pageData.recordsTotal / this.searchParams.length;
    }
  },
  created() {
    this.searchParams = clone(this.initSearchParams);
    this.loadUrlRedirectData();
  },
  methods: {
    // 搜索操作
    loadUrlRedirectDataBySearchWord(text) {
      this.searchParams.content = text;
      this.loadUrlRedirectData();
    },
    // 当前页改变操作
    onPageChange(pageNum) {
      this.searchParams.start = pageNum;
      this.loadUrlRedirectData();
    },
    async loadUrlRedirectData() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await listUrlRedirect(this.searchParams);
        this.pageData.recordsTotal = data.recordsTotal;
        this.pageData.urlRedirectList = data.data;
      } catch (error) {
        this.$message.error('加载URL列表失败');
      }
      this.$root.layout.isLoading = false;
    },
    handleSelectionChange: function(rows) {
      this.urlIds = [];
      this.isDelStatus = true;
      this.isEditStatus = true;
      if (rows.length > 0) {
        this.isDelStatus = false;
        if (rows.length === 1) {
          this.urlRedirectInfo = rows[0];
          this.isEditStatus = false;
        }
        rows.forEach(element => {
          this.urlIds.push(element.urlId);
        });
      }
    },
    // 添加
    showAddUrlWindow() {
      let versionDate = new Date();
      let versionValue = moment(versionDate).format('YYYYMMDD');
      this.dialogVisible = true;
      this.urlInfo.operType = 'add';
      this.urlInfo.urlId = null;
      this.urlInfo.urlCode = null;
      this.urlInfo.version = versionValue;
      this.urlInfo.jumpUrl = null;
      this.urlInfo.urlDesc = null;
    },
    // 修改
    showEditUrlWindow() {
      this.dialogVisible = true;
      this.urlInfo.operType = 'edit';
      this.urlInfo.urlId = this.urlRedirectInfo.urlId;
      this.urlInfo.urlCode = this.urlRedirectInfo.urlCode;
      this.urlInfo.version = this.urlRedirectInfo.version;
      this.urlInfo.jumpUrl = this.urlRedirectInfo.jumpUrl;
      this.urlInfo.urlDesc = this.urlRedirectInfo.urlDesc;
    },
    // 删除
    deleteUrlAndUser() {
      this.$ebConfirm('确认删除？').then(async result => {
        this.$root.layout.isLoading = true;
        try {
          if (this.urlIds.length > 0) {
            try {
              let urlIds = this.urlIds.join(',');
              let { data } = await deleteurlList(urlIds);
              if (data.returnCode === '01') {
                this.urlIds = [];
                this.loadUrlRedirectData();
                this.isDelStatus = true;
                this.$message.success('删除成功');
              }
            } catch (error) {
              this.$message.error('删除失败');
            }
          } else {
            this.$message.error('请选择要删除的机构');
          }
        } catch (error) {
          this.$message.error('删除失败');
        }
        this.$root.layout.isLoading = false;
      });
    },
    onSuccess: function() {
      this.loadUrlRedirectData();
    }
  }
};
</script>

<style  scoped lang='less'>
</style>
